// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2GGPU","description":"PatientConsentPreview_description__2a3Gy"};